import { useEffect, useState } from 'react'
import { Alert } from '@mui/material'
import { bannerEntryFor, bannerText, getEbayDailyLimits, subscribeEbayDailyLimits } from './ebayDailyLimit.js'

// The slim banner over the reply box (2026-10-29): eBay's daily message limit
// was reached on this contact's account less than an hour ago, and no send on
// it has gone through since. The list comes from the session tick.
export default function EbayDailyLimitBanner({ channel, company, actions }) {
  const [entries, setEntries] = useState(getEbayDailyLimits())
  const [now, setNow] = useState(Date.now())
  useEffect(() => subscribeEbayDailyLimits(setEntries), [])
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000)
    return () => clearInterval(t)
  }, [])
  const entry = bannerEntryFor(entries, { channel, company, actions, now })
  if (!entry) return null
  return (
    <Alert severity="warning" sx={{ mb: 1, py: 0, '& .MuiAlert-message': { py: 0.5 } }} data-testid="ebay-daily-limit-banner">
      {bannerText(entry)}
    </Alert>
  )
}
